import { Component, OnInit } from '@angular/core';
import { MetaDefinition, Title } from '@angular/platform-browser';
import { MetaService } from 'rigshare-common';
import { ButtonComponent } from 'rigshare-common';

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  standalone: true,
  imports: [ButtonComponent],
})
export class NotFoundComponent implements OnInit {
  /**
   * Create a new instance of the component.
   *
   * @param title
   * @param meta
   */
  constructor(public title: Title, public meta: MetaService) {}

  /**
   * The meta tags of the page.
   *
   * @type {MetaDefinition[]}
   */
  public metaTags: MetaDefinition[] = [
    {
      name: "description",
      content: "Share your favorite music gear",
    },
  ];

  /**
   * The title tag of the page.
   */
  public titleTag = "Sorry we couldn't find that page";

  /**
   * On component init.
   */
  ngOnInit(): void {
    this.title.setTitle(this.titleTag);
    this.meta.create(this.metaTags);
  }
}
